<div class="btn-group d-flex d-sm-inline-block" dropdown [insideClick]="insideClick">
    <button
        id="button-autoclose1"
        dropdownToggle
        type="button"
        class="btn btn-secondary dropdown-toggle overflow-button d-flex align-items-center justify-content-between text-start"
        aria-controls="dropdown-autoclose1"
        [disabled]="disabled"
        [ngClass]="{ 'disable-dropdown': disabled }"
    >
        {{ dropDownButtonText || defaultDropDownButtonText }}
    </button>
    <ul id="dropdown-autoclose1" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-autoclose1">
        <ng-content></ng-content>
    </ul>
</div>
